import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // import styles
import { Button } from "@mui/material";
import CodeIcon from "@mui/icons-material/Code";
import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import { useDeadline } from "../../../../contexts/DeadlineContext";
import ImageResize from "quill-image-resize-module-react"; // Import the image resize module
import "./EmailEditorStyle.css";

// Import image resize module
// Register the image resize module with Quill
ReactQuill.Quill.register("modules/imageResize", ImageResize);

const EmailEditor = (props) => {
    const id = props.match.params.id;
    const eventid = localStorage.getItem("eventid");
    const history = useHistory();
    const [editorState, setEditorState] = useState("");
    const [emailSubject, setEmailSubject] = useState("");
    const [emailtitleId, sestEmailtitleId] = useState("");

    const [isHtmlMode, setIsHtmlMode] = useState(false);
    const [htmlContent, setHtmlContent] = useState("");
    const { abstractHomeSetup } = useDeadline();
    const [htmlTemplateContent, setHtmlTemplateContent] = useState("");

    // Toggle between HTML and Quill mode
    const toggleHtmlMode = () => {
        setIsHtmlMode(!isHtmlMode);
        if (!isHtmlMode) {
            setHtmlContent(editorState);
        } else {
            setEditorState(htmlContent);
        }
    };


    // Load template content from the API (if needed)
    useEffect(() => {
        axios
            .get(`/api/get-email-html-template-content?id=${id}`)
            .then((res) => {
                if (res.status === 200) {
                    setHtmlTemplateContent(res.data.html_content);
                    setEditorState(res.data.html_content); // Set editor state
                    setEmailSubject(res.data.subject); // Set editor state
                    sestEmailtitleId(res.data.titleId); // Set editor state

                }
            })
            .catch((err) => console.error("Error loading template:", err));
    }, [id]);

    // Handle editor state change
    const handleChange = (content) => {
        setEditorState(content);
    };
    const images = document.querySelectorAll('.ql-editor img');

    images.forEach(image => {
        image.addEventListener('mousedown', function (e) {
            e.preventDefault(); // Prevent default drag behavior

            const startHeight = image.offsetHeight;
            const startY = e.clientY;

            const mouseMoveHandler = function (moveEvent) {
                const newHeight = startHeight - (moveEvent.clientY - startY);
                image.style.height = `${newHeight > 50 ? newHeight : 50}px`; // Prevent shrinking too small
            };

            const mouseUpHandler = function () {
                document.removeEventListener('mousemove', mouseMoveHandler);
                document.removeEventListener('mouseup', mouseUpHandler);
            };

            document.addEventListener('mousemove', mouseMoveHandler);
            document.addEventListener('mouseup', mouseUpHandler);
        });
    });
    // Submit content
    const handleSubmit = (e) => {
        e.preventDefault();
        const AbstractRegistrationEmail = "AbstractRegistrationEmail";
        const abstRegistrationEmailTemplate = isHtmlMode ? htmlContent : editorState;
        const data = {
            eventid,
            id,
            AbstractRegistrationEmail,
            abstRegistrationEmailTemplate,
        };

        axios.get("/sanctum/csrf-cookie").then(() => {
            axios.post("api/abstract-registration-email-template", data).then((res) => {
                if (res.data.status === 200) {
                    swal("Success", res.data.message, "success");
                } else {
                    swal("Warning", "Technical Issue. Please contact the technical team.", "warning");
                }
            });
        });
    };


    const downloadSample = () => {
        let sampleText = "";
        let fileName = "";
        if (emailtitleId == 1) {
            fileName = "AbstractRegistatrtion.txt"
            sampleText = `
                 {header_image}
                You have successfully Registered
                Hello {name},
                Thank you for registering in our system. We're thrilled to have you on board for this exciting journey of knowledge and innovation.
                Looking forward to an enriching and engaging experience together!
                Your Email: {email}
                Your Password: {password}
                Login
                Conference Website: https://microartonline.com/
                Best Regards,
                Team
                {footer_image}
            `;
        } else if (emailtitleId == 2) {
            fileName = "Abstractissue.txt"
            sampleText = `
           {header_image}
               
            Dear {name},

            Your Abstract title is : {abstract_title}

            the issue is

            {issues}

            {footer_image}
        `;
        }
        else if (emailtitleId == 3) {
            fileName = "AbstractRejecet.txt"
            sampleText = `
           {header_image}
          
            dear {name},

            your abstract is {abstract_title}

            on conference{conference_name}

            Rejected 



            {footer_image}
        `;
        }
        else if (emailtitleId == 4) {
            fileName = "AbstractOralpresentation.txt"
            sampleText = `
            {header_image}
            {submision_type}
             
            Dear {name},
            Your abstract title is: {abstract_title}
            On the conference: {conference_name}
            Date: {date}
            Time: {time}
            {footer_image}
        `;
        }
        else if (emailtitleId == 5) {
            fileName = "AbstractDigitalposter.txt"
            sampleText = `
            {header_image}
            {submision_type}
           
            Dear {name},
            Your abstract title is: {abstract_title}
            On the conference: {conference_name}
            Date: {date}
            Time: {time}
            {footer_image}
        `;
        }
        else if (emailtitleId == 6) {
            fileName = "Abstract.txt"
            sampleText = `
            {header_image}
            {submision_type}
            
            Dear {name},
            Your abstract title is: {abstract_title}
            On the conference: {conference_name}
            Date: {date}
            Time: {time}
            {footer_image}
        `;
        }

        else {
            fileName = "sample-email-template.txt";
            sampleText = `
                {header_image}
                You have successfully Registered
                Hello {name},
                Thank you for registering in our system. We're thrilled to have you on board for this exciting journey of knowledge and innovation.
                Looking forward to an enriching and engaging experience together!
                Your Email: {email}
                Your Password: {password}
                Login
                Conference Website: https://microartonline.com/
                Best Regards,
                Team
                {footer_image}
            `;
        }

        const blob = new Blob([sampleText], { type: "text/plain" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url); // Revoke the object URL to release memory
    };


    const backGroundButtonByEvent = eventid ? abstractHomeSetup.color_code_two : "#145348";

    return (
        <div style={{ width: "80%", margin: "5% auto", maxWidth: "900px" }}>
            <Button
                sx={{
                    float: "right",
                    marginTop: "2%",
                    backgroundColor: backGroundButtonByEvent,
                    ":hover": {
                        color: "white",
                    },
                }}
                color="success"
                size="small"
                variant="contained"
                onClick={() => {
                    history.goBack();
                }}
            >
                Back
            </Button>
            <h1 style={{ textAlign: "center" }}>{emailSubject} Email Template Editor</h1>

            {/* Toggle Button for HTML Mode */}
            {/* <div style={{ textAlign: "center", marginBottom: "20px" }}>
                <button
                    onClick={toggleHtmlMode}
                    style={{
                        backgroundColor: "#145348",
                        color: "white",
                        padding: "10px 20px",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontSize: "16px",
                        marginBottom: "10px",
                    }}
                >
                    <CodeIcon style={{ fontSize: "20px", color: "white", marginRight: "8px" }} />
                    {isHtmlMode ? "Switch to WYSIWYG" : "Switch to HTML"}
                </button>
            </div>
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
                <button
                    onClick={downloadSample}
                    style={{
                        backgroundColor: "#145348",
                        color: "white",
                        padding: "10px 20px",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontSize: "16px",
                    }}
                >
                    Download Sample
                </button>
            </div> */}
            <div style={{ textAlign: "center", marginBottom: "20px", display: "flex", justifyContent: "center", gap: "10px" }}>
                <button
                    onClick={toggleHtmlMode}
                    style={{
                        backgroundColor: backGroundButtonByEvent,
                        color: "white",
                        padding: "10px 20px",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontSize: "16px",
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <CodeIcon style={{ fontSize: "20px", color: "white", marginRight: "8px" }} />
                    {isHtmlMode ? "Switch to WYSIWYG" : "Switch to HTML"}
                </button>
                <button
                    onClick={downloadSample}
                    style={{
                        backgroundColor: backGroundButtonByEvent,
                        color: "white",
                        padding: "10px 20px",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontSize: "16px",
                    }}
                >
                    Download Sample
                </button>
            </div>


            {/* HTML Mode */}
            {isHtmlMode ? (
                <div style={{ border: "1px solid #ddd", borderRadius: "5px" }}>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            backgroundColor: "#f5f5f5",
                            padding: "10px",
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center" }}>

                            {/* Toolbar Buttons */}
                            <button
                                onClick={toggleHtmlMode}
                                style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    marginRight: "10px",
                                }}
                                title="Switch to WYSIWYG"
                            >
                                <CodeIcon style={{ fontSize: "20px", color: "gray" }} /> Toggle
                            </button>
                            <button
                                style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    marginRight: "10px",
                                }}
                                title="Bold"
                            >
                                <FormatBoldIcon style={{ fontSize: "20px", color: "gray" }} /> Bold
                            </button>
                            <button
                                style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    marginRight: "10px",
                                }}
                                title="Italic"
                            >
                                <FormatItalicIcon style={{ fontSize: "20px", color: "gray" }} /> Italic
                            </button>
                        </div>
                    </div>
                    <textarea
                        value={htmlContent}
                        onChange={(e) => setHtmlContent(e.target.value)}
                        rows={10}
                        style={{
                            width: "100%",
                            fontFamily: "monospace",
                            fontSize: "14px",
                            border: "none",
                            outline: "none",
                            padding: "10px",
                        }}
                    />
                </div>
            ) : (
                <ReactQuill
                    value={editorState}
                    onChange={handleChange}
                    theme="snow"
                    modules={{
                        toolbar: [
                            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
                            [{ 'size': ['small', false, 'large', 'huge'] }], // Add font size options
                            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                            ['bold', 'italic', 'underline'],
                            [{ 'color': [] }, { 'background': [] }],
                            ['link', 'image'],
                            [{ 'align': [] }],
                            ['clean'],
                        ],
                        imageResize: {
                            parchment: true,
                        },
                    }}
                />
                // <ReactQuill
                //     value={editorState}
                //     onChange={handleChange}
                //     theme="snow"
                //     modules={{
                //         toolbar: [
                //             [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
                //             [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                //             ['bold', 'italic', 'underline'],
                //             ['link', 'image'],
                //             [{ 'align': [] }],
                //             ['clean'],
                //         ],
                //         imageResize: {
                //             parchment: true, 
                //         },
                //     }}
                // />
            )}

            {/* Submit Button */}
            <div style={{ textAlign: "right", marginTop: "20px" }}>
                <button
                    onClick={handleSubmit}
                    style={{
                        backgroundColor: backGroundButtonByEvent,
                        color: "white",
                        padding: "10px 20px",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontSize: "16px",
                    }}
                >
                    Submit
                </button>
            </div>
        </div>
    );
};

export default EmailEditor;
